export default {
  de: {
    currency: 'Währung',
    tax: 'Steuersatz',
    getNumberRange: 'Nächsten Wert aus Nummernkreis laden',
    numberRanges: 'Nummernkreise',
    numberRange: 'Nummernkreis',
    pattern: 'Muster',
    counter: 'Aktueller Zähler',
    counterLength: "Zähler Länge",
    leadingZeros: 'Vorangestellte Nullen',
    reload: 'Stammdaten neu laden',
    price: 'Preis',
    unit: 'Einheit',
    manualReasons: 'Artikelnachverrechnung',
    notification: {
      create: {
        type: 'success',
        message: 'Stammdatensatz erfolgreich angelegt',
        title: 'Erfolgreich angelegt'
      },
      delete: {
        type: 'success',
        message: 'Stammdatensatz erfolgreich gelöscht',
        title: 'Erfolgreich gelöscht'
      }
    }
  }
}
